import fetch from '@/plugin/axios'

// 添加活动
export function getAddActivity (query) {
  return fetch({
    url: '/api/order/clock-in-theme/add',
    method: 'Post',
    data: query
  })
}

// 活动列表
export function getThemeList (query) {
  return fetch({
    url: '/api/order/clock-in-theme/list',
    method: 'Post',
    data: query
  })
}
// 上架活动
export function getThemeUp (id) {
  return fetch({
    url: `/api/order/clock-in-theme/up/${id}`,
    method: 'Get'
  })
}
// 下架活动
export function getThemeDown (id) {
  return fetch({
    url: `/api/order/clock-in-theme/down/${id}`,
    method: 'Get'
  })
}
// 活动信息
export function getThemeInfo (id) {
  return fetch({
    url: `/api/order/clock-in-theme/info/${id}`,
    method: 'Get'
  })
}
// 修改活动
export function getThemeUpdate (query, id) {
  return fetch({
    url: `/api/order/clock-in-theme/update/${id}`,
    method: 'Post',
    data: query
  })
}
// 标签选项
export function getOptions () {
  return fetch({
    url: '/api/order/clock-in-classify/options',
    method: 'Get'
  })
}

// 打卡任务选项
export function getClockInOptions (data) {
  return fetch({
    url: '/api/order/clock-in-theme/options',
    method: 'Post',
    data: data
  })
}

// @PostMapping("add-step/{themeId}")
// 添加步骤
export function addStep (themeId, form) {
  return fetch({
    url: `/api/order/clock-in-theme/add-step/${themeId}`,
    method: 'Post',
    data: form
  })
}
//     @ApiOperation("修改步骤")
//     @PostMapping("update-step/{id}")
//     ObjectRestResponse<Void> updateStep(@PathVariable("id") Long id,@RequestBody ClockInTaskForm form) {
//         clockInTaskService.updateStep(id,form);
//         return ObjectRestResponse.success();
// }
export function updateStep (id, form) {
  return fetch({
    url: `/api/order/clock-in-theme/update-step/${id}`,
    method: 'Post',
    data: form
  })
}

export function getStepList (themeId) {
  return fetch({
    url: `/api/order/clock-in-theme/task-list/${themeId}`,
    method: 'Get'
  })
}

// 删除
export function removeStep (id) {
  return fetch({
    url: `/api/order/clock-in-theme/step/${id}`,
    method: 'Delete'
  })
}
